import { create } from 'zustand';
import { useShallow } from 'zustand/react/shallow';

import { getAds, updateAdShow } from '@/shared/api/ad';

import { type Ad, type WrapperAdsState } from './wrapper-ads.types';

const defaultWrapperAdsState = {
  ads: [],
  shownAds: {},
};

export const useWrapperAdsStateRaw = create<WrapperAdsState>()((set, get) => ({
  ...defaultWrapperAdsState,
  actions: {
    hydrate: (fresh: Partial<WrapperAdsState>) => set(fresh),
    registerAdShowcase: (id: string | number) => {
      const { shownAds } = get();
      const shownAdsUpdated = { ...shownAds, [id]: true };
      set({ shownAds: shownAdsUpdated });
    },
    afterShowCallback: (ad: Ad) => {
      const { shownAds, actions } = get();
      if (!ad || shownAds[ad.id]) return;

      const { registerAdShowcase } = actions;
      registerAdShowcase(ad.id);
      updateAdShow(ad.id);
    },
    fetchAds: async () => {
      try {
        const ads = await getAds();

        set({ ads });
      } catch (err) {
        console.error('ERROR in fetchAds', err);
      }
    },
  },
}));

export const useWrapperAdsState = () =>
  useWrapperAdsStateRaw(
    useShallow((state) => ({
      ads: state.ads,
      shownAds: state.shownAds,
    }))
  );

export const useWrapperAdsActions = () => useWrapperAdsStateRaw((state) => state.actions);
